"use client";

import { HelpCircle } from "lucide-react";
import { getVisualCmsIcon } from "@/lib/visual-cms/icon-registry";

interface SafeIconProps {
  name?: string | null;
  className?: string;
  /** Fallback icon when the stored key isn't in our registry. */
  fallback?: React.ComponentType<{ className?: string }>;
}

/**
 * Renders a lucide icon by name from the curated registry. Falls back to a
 * neutral placeholder if the key isn't found (handles legacy entries where
 * admins typed a free-form icon name that we don't include).
 */
export function SafeIcon({ name, className, fallback: Fallback = HelpCircle }: SafeIconProps) {
  const Cmp = getVisualCmsIcon(name);
  if (!Cmp) return <Fallback className={className} aria-hidden />;
  return <Cmp className={className} aria-hidden />;
}
